import React, { type FC } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { Box, Inline, Stack, xcss, Text } from '@atlaskit/primitives';
import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import { IconTile } from '@atlaskit/icon';

import type { GroupPrincipal } from '../../../../commonTypes';

const i18n = defineMessages({
	groupText: {
		id: 'share-and-restrict-dialog.principal-details.group-text',
		defaultMessage: 'Group',
		description: 'Label indicating that an entity in a permissions table is a group',
	},
});

const principalDetailsStyle = xcss({
	overflowWrap: 'anywhere',
});

const iconContainer = xcss({
	borderRadius: '50%',
	width: '36px',
	height: '36px',
	backgroundColor: 'color.background.neutral',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	flexShrink: 0,
	marginTop: 'space.0',
});

export const GroupDetails: FC<GroupPrincipal> = ({ name }) => {
	const { formatMessage } = useIntl();

	return (
		<Inline space="space.150" alignBlock="center">
			<Box xcss={iconContainer}>
				<IconTile label="" size="32" appearance="gray" shape="circle" icon={PeopleGroupIcon} />
			</Box>
			<Stack xcss={principalDetailsStyle}>
				<Inline>{name}</Inline>
				<Text size="small" color="color.text.subtlest">{`${formatMessage(i18n.groupText)}`}</Text>
			</Stack>
		</Inline>
	);
};
